import { Col, DropdownMenu, Row } from '@paypalcorp/pp-react'
import { useApplicationContext } from '../../../context/ApplicationContext'
import React, { useEffect, useState } from 'react'
import { useMessage } from '../../../hooks'
import { getDateRangeSelection } from '../../../utils/session-utils'

function DateRangeSelect() {
  const {
    setDateRangeSelectorStart,
    setDateRangeSelectorEnd,
    setReloadPage,
  } = useApplicationContext()

  const [selectedRecord, setSelectedRecord] = useState()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()

  const setDateRangeSelection = (range) => {
    window.localStorage.setItem('dateRange', range)
    setSelectedRecord(range)
  }

  const localizedMsg = useMessage()
  const dateRangeOptions = [
    {
      value: '1',
      primaryText: 'Last 1 hour',
    },
    {
      value: '12',
      primaryText: 'Last 12 hours',
    },
    {
      value: '24',
      primaryText: 'Last 24 hours',
    },
    {
      value: '168',
      primaryText: 'Last 7 days',
    },
    {
      value: '336',
      primaryText: 'Last 14 days',
    },
  ]

  const subtractHoursToDate = (intHours) => {
    let numberOfMlSeconds = new Date().getTime()
    let addMlSeconds = intHours * 60 * 60 * 1000
    let newDateObj = new Date(numberOfMlSeconds - addMlSeconds)

    setStartDate(newDateObj)
    setEndDate(new Date())

    // also store via global ApplicationContext
    setDateRangeSelectorStart(newDateObj)
    setDateRangeSelectorEnd(new Date())
  }

  useEffect(() => {
    let dateRange = getDateRangeSelection()
    setSelectedRecord(dateRange ? dateRange : dateRangeOptions[1].value)
    subtractHoursToDate(dateRange ? dateRange : dateRangeOptions[1].value)
  }, [])

  const daterangecontent = (
    <>
      <Row>
        <Col>
          <DropdownMenu
            id="selected-date-range"
            label={localizedMsg('applications.date.range.dropdown.set')}
            options={dateRangeOptions}
            value={selectedRecord}
            startdate={startDate}
            enddate={endDate}
            onChange={(e) => {
              setDateRangeSelection(e.target.value)
              subtractHoursToDate(e.target.value)
              setReloadPage('yes')
            }}
            data-dxa={`
              Date Range Selector, 
              date-range-value-dropdown click,
            `}
          />
        </Col>
      </Row>
    </>
  )

  return <>{daterangecontent}</>
}

export default DateRangeSelect
